<template>
  <div class="home">
    <div
      :class="['background-img', bannerInfo.classify != '1' ? 'curs' : '']"
      :style="{ backgroundImage: 'url(' + bannerInfo.pic + ')' }"
      @click="bannerClick"
    >
      <!-- 导航栏 -->
      <div style="background: rgba(0, 0, 0, 0.2)">
        <div class="w navi flex" style="justify-content: space-between">
          <img
            style="height: 48px"
            :src="imgPrefix + findTopBar.logoWhite"
            alt=""
          />
          <div class="flex" style="justify-content: space-between; width: 50%">
            <div
              :class="item.link == '/' ? 'line_class' : ''"
              v-for="(item, index) in newNaviArr"
              :key="index"
              @click.stop="changeUrl(item.link, item)"
            >
              {{ item.name }}
            </div>
            <template v-if="userId">
              <a-dropdown>
                <a
                  class="ant-dropdown-link"
                  style="color: #ffffff"
                  @click="(e) => e.preventDefault()"
                >
                  {{ supUserName }}<a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a href="javascript:;" @click.stop="logout">退出登录</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <div v-else class="login_class" @click.stop="loginFn">登录</div>
            <!-- <div class="login_class" @click.stop="logout"> 登录</div> -->
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div
        class="w flex"
        style="justify-content: space-between; margin-top: 72px"
      >
        <div style="width: 66%">
          <div class="ban_title">
            <div>{{ findTopBar.sysName }}</div>
            <div>数据多跑路，师生少跑腿</div>
          </div>
          <!-- 搜索栏 -->
          <div class="w search_class">
            <div class="serach_box">
              <input
                class="serach_ipt"
                type="text"
                v-model.trim="keyWord"
                @click.stop="onClick"
                @keyup.enter="onSearch"
                placeholder="请输入您要查询的服务..."
              />
              <div @click.stop="onSearch" class="serach_bon">搜索</div>
            </div>
            <!-- <div class="flex" style="margin-top: 16px">
              <span>最近搜索：</span>
              <div class="search_tag" v-for="item in history" :key="item">
                <span>{{ item }}</span>
              </div>
            </div> -->
          </div>
        </div>
        <!-- 顶部办事栏 -->
        <div class="common_box">
          <div class="common_box_top flex">
            <div
              :class="[
                'common_box_title',
                index == commonIdx ? 'common_box_title_cls' : '',
              ]"
              v-for="(item, index) in commonTitle"
              :key="index"
              @click.stop="getFindTopBanner(index + 1)"
            >
              {{ item }}
            </div>
          </div>
          <div class="flex common_ul">
            <li
              class="common_li"
              v-for="(item, index) in commonList"
              :key="index"
              @click.stop="topWork(item)"
            >
              {{ item.name }}
            </li>
          </div>
        </div>
      </div>

      <!-- 指示栏 -->
      <div class="tips">
        <a
          href="javascript:;"
          v-for="item in sidebarList"
          :key="item.id"
          @click.stop="goToOrder(item)"
        >
          <template v-if="item.classify == 1 || item.classify == 2">
            <img :src="imgPrefix + item.icon" alt="" />
            <div>{{ item.name }}</div>
          </template>
          <template v-else>
            <a-popover placement="left">
              <template slot="content">
                <img
                  v-if="item.classify == 3"
                  :src="imgPrefix + item.content"
                  alt=""
                />
                <div v-else>{{ item.content }}</div>
              </template>
              <img :src="imgPrefix + item.icon" alt="" />
              <div>{{ item.name }}</div>
            </a-popover>
          </template>
        </a>
      </div>
    </div>

    <!-- 模块内容 -->
    <div v-for="item in homeModule" :key="item.code">
      <div
        class="flex w"
        v-if="item.status == 1"
        style="justify-content: space-between"
      >
        <div class="title">
          {{ item.name }}
          <span v-if="item.code == 1" class="work_service_time"
            >截止 {{ currentTime }} 共上线
            <span>{{ serviceTotal }}</span> 项服务，可线上办理服务{{serviceData[1].number}}项</span
          >
        </div>
        <div v-if="item.code == 5" class="check_more" @click="gotoNotice">
          查看更多
        </div>
      </div>

      <!-- 办事服务 -->
      <div v-if="item.code == 1 && item.status == 1" class="w work_service">
        <div class="flex work_navi">
          <div class="flex" style="border-bottom: 1px solid #ebeffc">
            <div
              v-for="(item, index) in workNaviData"
              :key="index"
              :class="[
                'work_box',
                index == 0 ? '' : 'work_cls',
                workIndex == index ? 'click_sty' : '',
              ]"
              @click="getFindService(index + 1)"
            >
              {{ item }}
            </div>
          </div>
          <div
            class="check_more"
            style="margin-bottom: 11px"
            @click="checkMoreWork()"
          >
            查看更多
          </div>
        </div>

        <div class="work_lattice flex">
          <div
            class="lat_out flex"
            v-for="(item, index) in workData"
            :key="index"
          >
            <img
              v-if="item.icon"
              :src="imgPrefix + item.icon"
              style="height: 80px"
              alt=""
            />
            <img
              v-else
              src="../assets/index/icon-default.png"
              style="height: 80px"
              alt=""
            />
            <div class="lat-r">
              <div class="lat_tit">
                {{ item.serviceManageName }}
                <span
                  :class="[
                    'work_tag',
                    item.priority == 3
                      ? 'work_tag_bg3'
                      : item.priority == 1
                      ? 'work_tag_bg2'
                      : '',
                  ]"
                  v-if="item.priority != 0"
                  >{{
                    item.priority == 1
                      ? "荐"
                      : item.priority == 3
                      ? "上新":''
                  }}</span >
                  <!-- &nbsp;<span v-if="item.isLimitTime" class="work_tag work_tag_bg1">限时</span> -->
              </div>
              <div class="lat_con flex">
                <!--  class="lat_con_cls" -->
                <div class="text_top" style="max-width: 82px">
                  {{
                    item.serviceClassifyName.length == 0
                      ? "暂无分类"
                      : item.serviceClassifyName[0]
                  }}
                </div>
                <a-divider type="vertical" />
                <div class="text_top">{{ item.serviceManageName }}</div>
              </div>
              <div class="flex lat_bom">
                <div class="flex lat_hot">
                  <img
                    class="pr_11"
                    src="../assets/index/icon-hot.png"
                    alt=""
                  />
                  <div>热度：{{ item.heatValue }}</div>
                </div>
                <div class="flex">
                  <img
                    class="pr_11"
                    src="../assets/index/icon-collection.png"
                    alt=""
                  />
                  <div>收藏：{{ item.collectValue }}</div>
                </div>
              </div>
            </div>
            <!-- idx == 2 ? '' : 'hover_box_fal' -->
            <!-- <div class="hover_cls">
              <a
                href="javascript:;"
                :class="['hover_box']"
                v-for="(subItem, idx) in workHover"
                :key="idx"
                @click="gotoWork(idx, item)"
                >
                <template  v-if="idx != 2">                  
                  <span>{{ subItem}}</span>
                </template>
                <template v-else>                  
                  <span v-if="item.isApply">{{ subItem}}</span>
                </template>
                <a-divider style="margin: 0 8%;opacity: 0.6" v-if="idx != 2" type="vertical" />
              </a>
            </div> -->
            <div class="hover_cls">
              <a
                href="javascript:;"
                :class="['hover_box']"
                @click="gotoWork(0, item)"
              >
                <span>添加收藏</span>
              </a>
              <a-divider style="opacity: 0.6; top: 0" type="vertical" />
              <a
                href="javascript:;"
                :class="['hover_box']"
                @click="gotoWork(1, item)"
              >
                <span>服务指南</span>
              </a>
              <a-divider
                v-if="item.isApply"
                style="opacity: 0.6; top: 0"
                type="vertical"
              />
              <a
                v-if="item.isApply"
                href="javascript:;"
                :class="['hover_box']"
                @click="gotoWork(2, item)"
              >
                <span>我要办理</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 特色专栏 -->
      <div v-if="item.code == 2 && item.status == 1" class="w feature">
        <a-carousel style="margin: -1rem">
          <div
            class="swiper_box"
            v-for="(el, index) in featureData"
            :key="index"
          >
            <div
              class="box_shadow"
              v-for="item in el"
              :key="item.id"
              @click="gotoThemeDetails(item)"
            >
              <div class="sip_hover">
                <img :src="imgPrefix + item.card" alt="图片" />
                <div class="swiper_con">
                  <div class="swiper_tit">{{ item.name }}</div>
                  <div class="swiper_clamp">{{ item.introduction }}</div>
                </div>
              </div>
            </div>
          </div>
        </a-carousel>
      </div>

      <!-- 服务统计 -->
      <div v-if="item.code == 3 && item.status == 1" class="service_data">
        <div class="service_data_bner">
          <div class="w flex data_box">
            <div
              class="sev_data_box"
              v-for="(item, index) in serviceData"
              :key="index"
            >
              <div class="sev_data_cls">{{ item.number }}</div>
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 快捷通道 -->
      <div v-if="item.code == 4 && item.status == 1" class="w shortcut">
        <div class="shortcut_big">
          <!-- <div class="flex"> -->
          <div
            class="shortcut_box"
            v-for="(item, index) in shortcutData"
            :key="index"
            @click="gotoShortcut(item.link)"
          >
            <div class="blue_line"></div>
            <img :src="imgPrefix + item.icon" alt="" />
            <div class="name">{{ item.name }}</div>
          </div>
          <!-- </div> -->
        </div>
      </div>

      <!-- 通知公告 -->
      <div v-if="item.code == 5 && item.status == 1" class="w notice">
        <div
          class="notice_big flex"
          :style="
            noticeData.length > 2 ? 'justify-content: space-between;' : ''
          "
        >
          <div
            class="notice_box"
            v-for="(item, index) in noticeData"
            :style="noticeData.length > 2 ? '' : 'margin-right:20px'"
            :key="index"
            @click="gotoNoticeDetails(item)"
          >
            <h2 class="notice_title ellipsis">{{ item.title }}</h2>
            <div class="con ellipsis" v-html="item.content"></div>
            <div class="flex bom_cls clearfix">
              <div class="bom">
                <img src="../assets/index/icon-time-gary-outline.png" alt="" />
                <span class="dept_css" style="max-width: 100px">{{
                  item.time
                }}</span>
              </div>
              <a-divider type="vertical" style="margin: 0 1.375rem" />
              <div class="bom">
                <img
                  src="../assets/index/icon-publisher-gary-outline.png"
                  alt=""
                />
                <span class="dept_css">{{ item.departmentName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import Footer from "../components/Footer.vue";

import imgPrefix from "../../utils/imgPrefix";
import { format } from "../../utils/utils";
import {
  findTopBarApi,
  findHoverApi,
  findTopBannerApi,
  findServiceApi,
  findNavApi,
  findHomeModuleApi,
  findFeatureColumnByListApi,
  findChannelApi,
  findNoticeApi,
  findServiceSummaryApi,
  logout,
} from "../api/index";

// 将一维数组中以四个元素为一个单位提取到一个数组中，建立一个二维数组
Array.prototype.chunk = function (len) {
  var len = parseInt(len);
  if (len <= 1 || this.length < len) return this;
  var groups = [],
    loop = Math.ceil(this.length / len);
  for (var i = 0; i < loop; i++)
    groups.push(this.slice(len * i, len * (i + 1)));
  return groups;
};
export default {
  data() {
    return {
      imgPrefix,
      bannerInfo: {},
      findTopBar: {},
      homeModule: {},
      sidebarList: [],
      naviArr: [],
      newNaviArr: [],
      commonTitle: ["学生常用", "教师常用"],
      commonIdx: 0,
      commonList: [],
      history: ["一卡通", "请假", "奖助学金"],
      dataLet: 2,
      featureData: [[]],
      workIndex: 0,
      workNaviData: ["学生办事", "教师办事", "访客办事"],
      workData: [],
      workHover: ["添加收藏", "服务指南", "我要办理"],
      serviceData: [
        { name: "当前进驻事项", number: "0" },
        { name: "可在线办理事项", number: "0" },
        { name: "进驻服务部门", number: "0" },
        { name: "在线办理覆盖率", number: "0" },
        // { name: "事项平均分", number: "3.5" },
      ],
      shortcutData: [],
      noticeData: [],
      currentTime: "",
      serviceTotal: 0,
      keyWord: "",
      userId: "",
      supUserName: "",
    };
  },
  components: { Footer },
  computed: {},
  watch: {},
  created() {
    // 获取登录后的userId
    this.userId = localStorage.getItem('userId');
    // 获取登录信息
    let info = localStorage.getItem('ly-portal-affairs-ui-userLogin');
    if(localStorage.getItem('ly-portal-affairs-ui-userLogin')){
      info = JSON.parse(info)
      // console.log(info);
      this.supUserName = info?.userName;
    }
    // 获取当前时间
    let time = new Date();
    this.currentTime = format(time, "yyyy-MM-dd");
    sessionStorage.setItem("naviId", 0);
    // 获取顶部栏基本信息
    findTopBarApi().then((res) => {
      // console.log(res);
      this.findTopBar = res;
      document.title = res.sysName;
      // 改变主题颜色
      const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", res.topicColor);
      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + res.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
      sessionStorage.setItem("findTopBar", JSON.stringify(res));
    });
    // 获取顶部导航
    findNavApi().then((res) => {
      // console.log(res);
      this.naviArr = res;
      this.newNaviArr = res.filter(item => {
        return item.status == '1'
      })
      res.forEach(item => {        
        if (item.link == '/') {
          this.bannerInfo = item.navBannerVoList[0];
          this.bannerInfo.pic = this.imgPrefix + this.bannerInfo.pic;
        }
      });
      sessionStorage.setItem("naviArr", JSON.stringify(res));
    });
    // 获取顶部栏悬浮按钮信息
    findHoverApi().then((res) => {
      // console.log(res);
      this.sidebarList = res;
    });
    // 服务统计
    findServiceSummaryApi().then((res) => {
      this.serviceData[0].number = res.allServiceNumber;
      this.serviceData[1].number = res.availableServiceNumber;
      this.serviceData[2].number = res.serviceDeptNumber;
      this.serviceData[3].number =
        (res.availableServiceRate * 100).toFixed(2) + "%";
    });

    // 获取模块标题和状态
    findHomeModuleApi().then((res) => {
      // console.log(res);
      this.homeModule = res;
      res.forEach((item) => {
        if (item.code == 1) {
          if (item.status == 1) {
            this.getFindService(1);
          }
        }
        if (item.code == 2) {
          if (item.status == 1) {
            this.getFindFeatureColumnByList();
          }
        }
        if (item.code == 4) {
          if (item.status == 1) {
            this.getFindChannel(item.code);
          }
        }
        if (item.code == 5) {
          if (item.status == 1) {
            this.getFindNotice(item.code);
          }
        }
      });
    });

    this.getFindTopBanner(1);
  },

  mounted() {
    new Swiper(".swiper-container", {
      //  direction: 'vertical', // 垂直切换选项
      //mousewheel: true, //滚轮
      autoplay: {
        //自动开始
        delay: 25000, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      loop: true, // 循环模式选项

      // slidesPerView: 1,
      // spaceBetween: 40,
      // breakpointsInverse: true,
      breakpoints: {
        //当宽度大于等于320
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        //当宽度大于等于480
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        //当宽度大于等于640
        640: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },

      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // 分页器可以点击
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // 如果需要滚动条
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  },
  methods: {
    // 获取顶部办事栏
    getFindTopBanner(e) {
      let str = `[${e}]`;
      this.commonIdx = e - 1;
      findTopBannerApi({ targets: str })
        .then((res) => {
          // console.log(res);
          this.commonList = res;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },

    // 查询首页-办事服务列表
    getFindService(e) {
      let dto = {
        page: 1,
        pageSize: 9,
        targets: `[${e}]`,
      };
      this.workIndex = e - 1;
      findServiceApi(dto)
        .then((res) => {
          // console.log(res);
          this.serviceTotal = res.serviceNumber;
          this.workData = res.voList.list;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取特色专栏
    getFindFeatureColumnByList() {
      findFeatureColumnByListApi({ page: 1, pageSize: 12 }).then((res) => {
        // console.log(res);
        // this.featureData = res.list;
        if (res.list.length < 5) {
          this.featureData = [res.list];
        } else {
          this.featureData = res.list.chunk(4);
        }
      });
    },
    // 获取快捷通道
    getFindChannel(code) {
      findChannelApi(code).then((res) => {
        // console.log(res);
        this.shortcutData = res;
      });
    },
    // 获取通知公告
    getFindNotice() {
      findNoticeApi({ page: 1, pageSize: 3 }).then((res) => {
        // console.log(res);
        res.list.forEach((item) => {
          item.time = format(item.createTime, "yyyy-MM-dd");
        });
        this.noticeData = res.list;
      });
    },

    // 切换导航栏
    changeUrl(url, val) {
      if (val.classify == 1) {
        this.$router.push(`${url}?naviId=${val.id}`);
      } else {
        window.open(url);
      }
    },
    bannerClick() {
      // return
      if (this.bannerInfo.classify == 2) {
        this.$router.push(
          `${this.bannerInfo.link}?naviId=${this.bannerInfo.id}`
        );
      } else if (this.bannerInfo.classify == 3) {
        window.open(this.bannerInfo.link);
      }
    },
    onClick() {},
    onSearch(e) {
      // let val = e.target.value;
      // console.log(val,this.keyWord);
      // 阻止冒泡
      event.stopPropagation();
      if (this.keyWord) {
        this.naviArr.forEach((item) => {
          if (item.link == "/") {
            sessionStorage.setItem("searchKeyWord", this.keyWord);
            this.$router.push("/search?naviId=" + item.id);
          }
        });
      } else {
        this.$message.info("请输入关键字");
      }
    },
    loginFn() {
      // window.open("https://portal.ly-sky.com:7435/swzx/#/login");
      // this.$router.push("/login");
      window.open('http://chall.gdufe.edu.cn/qzqdht/')
    },
    logout() {
      let that = this;
      this.$confirm({
        title: "确认退出登录么？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          let headers = {
            // "userAuthType": "MS"
            "X-Requested-With": "XMLHttpRequest",
            gatewayAppId: "ly-portal-affairs",
            gatewayserviceid: "ly-portal-affairs-svc",
            Authorization: global.tokenId,
            Loginuserid: global.userId,
            Loginuserorgid: global.orgId,
          };
          logout("", headers)
            .then((e) => {
              // console.log('e', e);
            })
            .catch((res) => {
              // console.log(res);
              // sessionStorage.removeItem('ly-portal-affairs-ui-userLogin')
              sessionStorage.clear();
              that.$message.success("登出成功！");
              setTimeout(() => {
                that.$router.push("/login");
              }, 500);
              // window.location = window.casLogoutUrl;
            });
        },
      });
    },
    goToOrder(item) {
      if (item.classify == 1) {
        this.$router.push(item.content);
      } else if (item.classify == 2) {
        window.open(item.content);
      }
    },
    // 跳转主题详情
    gotoThemeDetails(e) {
      this.naviArr.forEach((item) => {
        if (item.link == "/theme") {
          this.$router.push(
            "/themeDetails?themeId=" + e.id + "&naviId=" + item.id
          );
        }
      });
    },
    // 跳转查看指南
    gotoWork(idx, e) {
      if (idx == 0) {
        window.open("https://portal.ly-sky.com:6208/#/login");
      } else if (idx == 1) {
        this.naviArr.forEach((item) => {
          if (item.link == "/serviceHall") {
            this.$router.push(
              "/serviceDetails?serviceManageId=" + e.id + "&naviId=" + item.id
            );
          }
        });
      } else if (idx == 2) {
        window.open(e.pcUrl);
      }
    },
    topWork(val) {
      this.naviArr.forEach((item) => {
        if (item.link == "/serviceHall") {
          this.$router.push(
            "/serviceDetails?serviceManageId=" +
              val.serviceManageId +
              "&naviId=" +
              item.id
          );
        }
      });
    },
    // 跳转办事大厅
    checkMoreWork() {
      this.naviArr.forEach((item) => {
        if (item.link == "/serviceHall") {
          this.$router.push("/serviceHall?naviId=" + item.id);
        }
      });
    },
    // 快捷通道
    gotoShortcut(url) {
      window.open(url);
    },
    gotoNotice() {
      this.$router.push("/notice?");
    },
    gotoNoticeDetails(val) {
      this.$router.push("/noticeDetails?noticeId=" + val.id);
    },
  },
};
</script>

<style scoped lang="less">
.home {
  width: 100%;
  .curs {
    cursor: pointer;
  }
  .title {
    font-weight: 700;
    font-size: 32px;
    color: #0d1c28;
    text-align: left;
  }
  .background-img {
    background: url("../assets/icon/pic-schoolbg.png") no-repeat center;
    background-size: cover;
    text-align: left;
    height: 492px;
    margin-bottom: 40px;
    position: relative;
    .top {
      justify-content: space-between;
      padding-top: 24px;
      margin-bottom: 33px;
      .top_head {
        color: #fff;
        font-size: 14px;
        .top_head_box {
          color: #fff;
          padding: 0 32px;
          position: relative;
          cursor: pointer;
        }
        .pseudo_class::after {
          content: "";
          position: absolute;
          top: 20%;
          right: -3%;
          width: 1px;
          height: 14px;
          background: #fff;
          opacity: 0.5;
        }
      }
    }
    .navi {
      color: #fff;
      height: 88px;
      div {
        // margin-right: 4.18rem;
        font-size: 16px;
        cursor: pointer;
        position: relative;
      }
      .line_class {
        font-weight: 600;
        // border-bottom: 2px solid #fff;
      }
      .line_class::after {
        content: "";
        position: absolute;
        bottom: -17px;
        left: 50%;
        transform: translate(-50%);
        width: 100%;
        height: 2px;
        background: #fff;
      }
      .login_class {
        background: rgba(255, 255, 255, 0.2);
        padding: 5px 12px;
        border-radius: 4px;
      }
    }
    .navi div:last-child {
      margin-right: 0;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #fff;
      opacity: 0.2;
    }
    .ban_title {
      color: #ffffff;
      div {
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
      }
    }
    .ban_title div:first-child {
      font-size: 56px;
      // margin-top: 47px;
      // margin-top: 72px;
      margin-bottom: 7px;
      font-weight: 800;
    }
    .ban_title div:last-child {
      font-size: 24px;
      color: #ffffff;
    }
    .search_class {
      margin: 20px 0 0;
      padding: 0;
      color: #fff;
      width: 80%;
      .serach_box {
        display: flex;
        align-items: center;
        height: 60px;
        border-radius: 2px;
        background: #fff;
        font-size: 16px;
        .serach_ipt {
          color: #7a8ba4;
          padding: 18px 20px;
          flex: 3;
        }
        .serach_bon {
          background: var(--themeColor);
          color: #fff;
          flex: 1;
          padding: 18px 0;
          text-align: center;
        }
      }
      .search_tag {
        // background: #396ee5;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 4px;
        padding: 0 15px;
        margin-right: 12px;
        line-height: 28px;
        img {
          width: 16px;
          margin-left: 9px;
          cursor: pointer;
        }
      }
    }
    .common_box {
      background: #fff;
      box-shadow: 0px 3px 20px rgba(9, 41, 77, 0.1);
      border-radius: 2px;
      padding: 20px 30px;
      // width: 424px;
      height: 260px;
      overflow-y: auto;
      width: 35.3%;
      max-width: 26.2rem;
      min-width: 15rem;
      .common_box_top {
        // border-bottom: 1px solid #e7e7e7;
        .common_box_title {
          font-size: 18px;
          line-height: 27px;
          font-weight: 600;
          margin-right: 38px;
          cursor: pointer;
        }
        .common_box_title_cls {
          color: var(--themeColor);
          border-bottom: 2px solid var(--themeColor);
        }
      }
      .common_ul {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 25px;
        .common_li {
          margin-bottom: 14px;
          width: 46%;
          // 超出10字省略
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          .common_yuan {
            width: 5px;
            height: 5px;
            background: #1f2c4b;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
        .common_li:hover {
          color: var(--themeColor);
        }
      }
    }
    .tips {
      padding: 2px 12px;
      position: absolute;
      right: 1%;
      // top: 45%;
      top: 221px;
      width: 72px;
      background: #fff;
      border-radius: 4px;
      text-align: center;
      box-shadow: 5px 6px 38px rgba(9, 41, 77, 0.1);
      a {
        // padding: 15px 0;
        padding: 16px 0;
        display: block;
        border-bottom: 1px solid #e2eef8;
        &:last-child {
          border-bottom: none;
        }
        img {
          width: 24px;
        }
        div {
          font-size: 12px;
          color: #555555;
        }
      }
    }
  }

  // 特色专栏
  .feature {
    margin-top: 22px;
    margin-bottom: 56px;
    height: 21rem;
    .swiper_box {
      display: flex !important;
      .box_shadow {
        width: 25%;
        padding: 1rem;
        cursor: pointer;
        .sip_hover {
          height: 16.625rem;
          transition: all 0.3s ease;
          box-shadow: 0px 0px 18px rgba(122, 139, 164, 0.15);
        }
      }
      img {
        width: 100%;
        height: 8.75rem;
      }
      .swiper_con {
        padding: 24px;
        text-align: left;
        .swiper_tit {
          font-size: 20px;
          color: #0d1c28;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .swiper_clamp {
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #727475;
        }
      }
    }
    .sip_hover:hover {
      transition: all 0.3s ease;
      background: #1890ff;
      transform: translate3d(0, -0.3rem, 0);
      .swiper_tit,
      .swiper_clamp {
        color: #fff;
      }
    }
  }
  /deep/.ant-carousel .slick-dots li.slick-active button {
    background: var(--themeColor);
    height: 4px;
  }
  /deep/.ant-carousel .slick-dots li button {
    background: #ccc;
    width: 24px;
    height: 4px;
  }
  /deep/.ant-carousel .slick-dots-bottom {
    bottom: -15px;
  }

  .work_service_time {
    font-size: 14px;
    color: #7a8ba4;
    font-weight: 500;
    margin-left: 32px;
    span {
      color: rgba(255, 122, 0, 1);
    }
  }
  // 办事服务
  .work_service {
    margin-bottom: 56px;
    margin-top: 14px;
    .work_navi {
      justify-content: space-between;
      .work_box {
        padding-bottom: 11px;
        // border-bottom: 1px solid #EBEFFC;
        font-size: 20px;
        color: #374567;
        margin-left: 40px;
        margin-right: 40px;
        position: relative;
        cursor: pointer;
        &:first-child {
          margin-left: 0;
        }
      }
      .click_sty {
        // color: #396ee5;
        color: var(--themeColor);
        border-bottom: 2px solid var(--themeColor);
      }
      .work_cls::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 16px;
        background: #ebeffc;
        top: 20%;
        left: -46%;
      }
    }
    .work_lattice {
      margin-top: 32px;
      justify-content: normal;
      flex-wrap: wrap;
      .lat_out {
        height: 175.5px;
        padding: 32px 24px;
        border: 1px solid #e0e5f0;
        width: 32%;
        margin-bottom: 20px;
        position: relative;
        transition: all 0.3s ease;
        overflow: hidden;
        margin-right: 0;
        align-items: normal;
        .lat-r {
          // margin-left: 24px;
          margin-left: 5%;
          text-align: left;
          color: #7a8ba4;
          overflow: hidden;
          width: 100%;
          .lat_tit {
            font-size: 18px;
            color: #374567;
            margin-bottom: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            position: relative;
            .work_tag {
              border-radius: 9px;
              padding: 0 6px;
              font-size: 12px;
            }
            // .work_tag_bg1 {
            //   border: 1px solid #f5212d;
            //   color: #f5212d;
            // }
            .work_tag_bg1 {
              background: #f5212d;
              color: #fff;
            }
            .work_tag_bg2 {
              background: #ff8a00;
              color: #fff;
            }
            .work_tag_bg3 {
              border: 1px solid #008d1f;
              color: #008d1f;
            }
          }
          .lat_con {
            font-size: 14px;
            // margin-bottom: 12%;
            margin-bottom: 24px;
            .text_top {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              position: relative;
            }
          }
          .lat_con div:first-child {
            margin-right: 16px;
          }
          .lat_con div:last-child {
            margin-left: 16px;
          }
          .lat_con_cls::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 16px;
            top: 5%;
            right: 5%;
            background: #ebeffc;
          }
          .lat_bom {
            width: 100%;
            div {
              flex: 1;
            }
          }
          .lat_hot {
            // margin-right: 32px;
            // margin-right: 9%;
          }
          .pr_11 {
            // padding-right: 11px;
            padding-right: 10%;
          }
        }
        .hover_cls {
          display: none;
          vertical-align: middle;
        }
      }
      .lat_out:hover {
        transition: all 0.3s ease;
        .hover_cls {
          // display: block;
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: absolute;
          bottom: 0;
          left: 0;
          // background: rgba(57, 110, 229, 0.8);
          background: var(--themeColor);
          box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.4);
          backdrop-filter: blur(4px);
          padding: 2% 8%;
          width: 100%;
          .hover_box {
            font-size: 14px;
            color: #fff;
            position: relative;
          }
          .hover_box_fal::after {
            content: "";
            position: absolute;
            top: 14%;
            right: -1%;
            width: 1px;
            height: 16px;
            background: #fff;
          }
        }
      }
      .lat_out:not(:nth-child(3n)) {
        margin-right: calc(8% / 4);
      }
    }
  }

  // 查看更多按钮
  .check_more {
    color: #396ee5;
    border: 1px solid #396ee5;
    border-radius: 4px;
    padding: 10px 22px;
    cursor: pointer;
    font-size: 14px;
  }

  // 服务统计
  .service_data {
    margin-bottom: 64px;
    .service_data_bner {
      margin-top: 22px;
      padding: 51px 0;
      width: 100%;
      height: 190px;
      background: url("../assets/index/server-banner.png") no-repeat center;
      background-size: cover;
      .data_box {
        justify-content: space-between;
        .sev_data_box div:first-child {
          font-size: 32px;
          font-weight: 700;
          color: #1f2c4b;
          padding-bottom: 16px;
          position: relative;
        }
        .sev_data_box div:last-child {
          font-size: 16px;
          color: #7a8ba4;
        }
        .sev_data_cls::after {
          content: "";
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translate(-50%);
          width: 32px;
          height: 2px;
          background: var(--themeColor);
        }
      }
    }
  }

  // 快捷通道
  .shortcut {
    margin-bottom: 64px;
    .shortcut_big {
      margin-top: 22px;
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      text-align: left;
      border-left: 1px solid #e0e5f0;
      // border-top: 1px solid #e0e5f0;

      .shortcut_box {
        position: relative;
        width: 16.6%;
        display: block;
        padding: 28px 24px;
        border-right: 1px solid #e0e5f0;
        border-bottom: 1px solid #e0e5f0;
        cursor: pointer;
        transition: all 0.3 ease;
        box-sizing: border-box;
        background: url("../assets/icon/banner-2.png") no-repeat right bottom;
        .name {
          color: #374567;
          font-weight: 500;
          font-size: 16px;
        }
        img {
          margin-bottom: 23px;
          width: 44px;
        }
        // .blue_line{
        //   display: none;
        // }
      }
      .shortcut_box:nth-child(1),
      .shortcut_box:nth-child(2),
      .shortcut_box:nth-child(3),
      .shortcut_box:nth-child(4),
      .shortcut_box:nth-child(5),
      .shortcut_box:nth-child(6) {
        border-top: 1px solid #e0e5f0;
      }
      .shortcut_box:hover {
        transition: all 0.3 ease;
        .blue_line {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          height: 4px;
          width: 100%;
          background: #396ee5;
        }
        box-shadow: 0 10px 20px 0 #ecedf4;
      }
    }
  }

  // 超出省略
  .ellipsis {
    // -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // 通知公告
  .notice {
    margin-bottom: 96px;
    .notice_big {
      text-align: left;
      margin-top: 24px;
      .notice_box {
        padding: 24px;
        box-shadow: 0px 0px 24px rgba(122, 139, 164, 0.25);
        width: 32%;
        display: flex;
        flex-direction: column;
        height: 240px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .notice_title {
          -webkit-line-clamp: 2;
          margin-bottom: 24px;
        }
        .con {
          color: #7a8ba4;
          margin-bottom: 28px;
          -webkit-line-clamp: 3;
        }
        .bom {
          // margin-right: 42px;
          color: #7a8ba4;
          position: relative;
          display: flex;
          align-items: center;
          img {
            margin-right: 9px;
          }
          .dept_css {
            display: block;
            overflow: hidden;
            // max-width: 166px;
            max-width: 10.375rem;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .bom_cls {
          position: absolute;
          bottom: 24px;
        }
      }
    }
  }
}
/deep/.ant-btn-primary {
  background-color: var(--themeColor);
  border-color: var(--themeColor);
}
/deep/.ant-input-group-wrapper {
  width: 100%;
}
/deep/.ant-btn-lg {
  height: 56px;
  padding: 0 55px;
}
/deep/.ant-input-lg {
  height: 56px;
}

/deep/.swiper-pagination-bullet {
  width: 24px;
  height: 4px;
  border-radius: 0;
}
/deep/.ant-input-group .ant-input {
  border: none;
  box-shadow: none;
}
</style>
